<template>
  <div>
    <h6>{{ question.label }} {{ question.required ? '*' : '' }}</h6>
    <div class="mb-2" v-html="question.description"></div>
    <b-form-group>
      <b-form-radio-group
        :size="size"
        :name="question.slug"
        v-model="answer"
        :stacked="!question.options.inline || !!question.options.description"
        :required="question.required"
        :state="!!errors ? false : null"
        @change="$emit('clear-error', question.slug)"
      >
        <b-form-radio
          v-for="(o, index) in radio_options"
          :key="index"
          :value="o.value"
        >
          {{ o.value }}
          <div v-if="o.description" v-html="o.description"></div>
        </b-form-radio>
        <b-button v-if="!question.required && !!answer" variant="link" size="sm" class="text-muted p-0" @click="onClear">
          <i class="fa fa-fw fa-times"></i>
          {{ trans('clear') }}
        </b-button>
      </b-form-radio-group>
      <div v-if="question.options.other_option">
        <label class="mb-0">
          {{ question.options.other_label || trans('please_specify') }}
        </label>
        <b-form-input
          v-model="other"
          :state="!!errors ? false : null"
          @change="$emit('clear-error', question.slug)"
        ></b-form-input>
      </div>
      <b-form-invalid-feedback :state="!!errors ? false : null">
        {{ (errors||[]).join(' ') }}
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

<script>

  function extract(question, value) {
    if (!value ||
      !question.options.values ||
      question.options.values.length == 0)
      return [value, null]
    let found = _.reduce(question.options.values || [], (found, option) => {
      if (value != option && value.indexOf(option+' - ') === 0) found = option
      return found
    }, null)
    if (!found) return [value, null]
    let other = value.replace(found + ' - ', '')
    value = found
    return [value, other || null]
  }

  export default {
    props: {
      value: String, // answer
      question: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
      errors: Array,
    },
    data() {
      let answer, other
      [answer, other] = extract(this.question, this.value)
      return {
        trans: trans,
        answer: answer,
        other: other,
      }
    },
    computed: {
      radio_options() {
        let descriptions = this.question.options.descriptions || null
        return (this.question.options.values || []).map((value, i) => {
          return {
            value: value,
            description: descriptions ? descriptions[i] : null
          }
        })
      },
      values() {
        let other = this.question.options.other_option && this.other ? this.other : null
        return (this.question.options.values || []).map(value => {
          return {
            value: other && other.indexOf(value+' - ') === 0 ? other : value,
            text: value
          }
        })
      },
      answerWithOther() {
        let answer = this.answer
        if (this.other) answer += ' - ' + this.other
        return answer
      },
    },
    watch: {
      answer() {
        if (this.answerWithOther !== this.value) this.$emit('input', this.answerWithOther)
      },
      other() {
        if (this.answerWithOther !== this.value) this.$emit('input', this.answerWithOther)
      },
      value() {
        let answer, other
        [answer, other] = extract(this.question, this.value)
        this.answer = answer
        this.other = other
      },
    },
    methods: {
      onClear() {
        this.answer = null
      },
    },
    mounted() {
      window['formQuestionRadios'+(this.question.id||'')] = this
    },
  }
</script>